import { useAppTheme, useLocale } from '@capsicum/common';
import SumsubWebSdk from '@sumsub/websdk-react';
import { useMemo } from 'react';
import styled from 'styled-components';

import type { SumsubEventListeners } from '../../hooks/useSumsubIdentityVerification';
import type { SnsWebSdkBaseConfig } from '@sumsub/websdk/types/types';

export type SumsubSdkWrapperProps = {
	authToken: string;
} & SumsubEventListeners;

export const SumsubSdkWrapper = ({
	authToken,
	onSdkAccessTokenExpiration,
	onSdkError,
	onSdkMessage
}: SumsubSdkWrapperProps) => {
	const { locale } = useLocale();
	const { mode } = useAppTheme();

	const config: SnsWebSdkBaseConfig = useMemo(() => {
		return {
			lang: locale.split('-')[0],
			theme: mode
		};
	}, [locale, mode]);

	return (
		<S.Sumsub
			accessToken={authToken}
			config={config}
			expirationHandler={onSdkAccessTokenExpiration}
			onError={onSdkError}
			onMessage={onSdkMessage}
		/>
	);
};

namespace S {
	export const Sumsub = styled(SumsubWebSdk)`
		> iframe {
			min-height: 75dvh !important;
			overflow-y: scroll;
			${({ theme }) => theme.breakpoints.queries.below.mobile} {
				min-height: 70dvh !important;
			}
		}
	`;
}
